import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import _ from 'lodash'

Vue.use(Vuex)

const emptyNotifications = {
  error: [],
  info: [],
  success: []
}

export default new Vuex.Store({
  strict: true,
  plugins: [
    createPersistedState()
  ],
  state: {
    token: null,
    acceptedTerms: null,
    customers: [],
    customer: null,
    messages: {},
    showMultipleUsersSnackbar: false
  },
  mutations: {
    setToken (state, token) {
      state.token = token
    },
    setAcceptedTerms (state, acceptedTerms) {
      state.acceptedTerms = acceptedTerms
    },
    setCustomer (state, customer) {
      state.customer = customer
    },
    setCustomers (state, customers) {
      state.customers = customers
    },
    addNotification (state, message) {
      state.messages[message.group] = state.messages[message.group] || _.cloneDeep(emptyNotifications)
      state.messages[message.group][message.type].push(message.text)
    },
    clearNotifications (state, group) {
      state.messages[group] = _.cloneDeep(emptyNotifications)
    },
    setShowMultipleUsersSnackbar (state, value) {
      state.showMultipleUsersSnackbar = value
    }
  },
  actions: {
    setToken ({commit}, token) {
      commit('setToken', token)
    },
    setAcceptedTerms ({commit}, acceptedTerms) {
      commit('setAcceptedTerms', acceptedTerms)
    },
    setCustomer ({commit}, customer) {
      commit('setCustomer', customer)
    },
    setCustomers ({commit}, customers) {
      commit('setCustomers', customers)
    },
    consumeNotifications ({commit}, group) {
      const ret = _.cloneDeep(this.state.messages[group] || emptyNotifications)
      commit('clearNotifications', group)
      return ret
    },
    setShowMultipleUsersSnackbar ({commit}, value) {
      commit('setShowMultipleUsersSnackbar', value)
    },
    clear ({commit}) {
      commit('setToken', null)
      commit('setAcceptedTerms', null)
      commit('setCustomers', null)
      commit('setCustomer', null)
      commit('setShowMultipleUsersSnackbar', false)
    }
  },
  getters: {
    getAcceptedTerms: state => state.acceptedTerms,
    getCustomer: state => state.customer,
    getCustomers: state => state.customers
  }
})
